import React, { useState } from 'react';
import { IntegrationSC } from './integration.styled';
import IntegrationOptions from './integration-options';
import IntegrationCode from './integration-code';
import IntegrationContact from './integration-contact';
import IntegrationHowTo from './integration-howto';
import { SHOWED_INT_MODAL } from '../../constants/local-storage';

type TProps = {
  onProceed(): void;
};

const STEPS = {
  OPTIONS: 'OPTIONS',
  CODE: 'CODE',
  CONTACT: 'CONTACT',
  HOWTO: 'HOWTO',
};

const Integration: React.FC<TProps> = ({ onProceed }) => {
  const [step, setStep] = useState(STEPS.OPTIONS);

  const onProceedClick = () => {
    localStorage.setItem(SHOWED_INT_MODAL, 'true');
    onProceed();
  };

  return (
    <IntegrationSC>
      {step === STEPS.OPTIONS ? (
        <IntegrationOptions
          onProceed={() => onProceedClick()}
          onChoose={() => {
            setStep(STEPS.CODE);
          }}
          onOther={() => setStep(STEPS.CONTACT)}
        />
      ) : null}
      {step === STEPS.CODE ? (
        <IntegrationCode
          onDone={onProceedClick}
          onBack={() => setStep(STEPS.OPTIONS)}
          onHelp={() => setStep(STEPS.HOWTO)}
        />
      ) : null}
      {step === STEPS.CONTACT ? (
        <IntegrationContact onDone={onProceedClick} onBack={() => setStep(STEPS.OPTIONS)} />
      ) : null}
      {step === STEPS.HOWTO ? <IntegrationHowTo onBack={() => setStep(STEPS.OPTIONS)} /> : null}
    </IntegrationSC>
  );
};

export default Integration;
